import { Service } from './http-service';

class RootService extends Service<undefined, undefined, undefined> {
  async reloadFeatureFlags() {
    await this.httpClient.post(`/reload-feature-flags`);
  }
}

export const rootService = new RootService('');
